type QueryValue = string | number | boolean | null | undefined | object;

/**
 * Builds a `?a=1&b=2` suffix for iframe modal URLs.
 * Skips entries whose value is empty/null/undefined; JSON-encodes objects/arrays;
 * URI-encodes everything else.
 */
export function buildIframeQueryString(
  params: Record<string, QueryValue>,
  options: { leading?: '?' | '&' | '' } = {},
): string {
  const parts: string[] = [];
  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined || value === '') {
      continue;
    }
    if (typeof value === 'boolean') {
      parts.push(`${key}=${value}`);
      continue;
    }
    const encoded =
      typeof value === 'object'
        ? encodeURIComponent(JSON.stringify(value))
        : encodeURIComponent(String(value));
    parts.push(`${key}=${encoded}`);
  }
  if (parts.length === 0) return '';
  const leading = options.leading ?? '?';
  return `${leading}${parts.join('&')}`;
}

export const clientTypeFromIsCompany = (isCompany: boolean | undefined | null) =>
  isCompany ? 'company' : 'individual';
